/*
 * @Author: Merlin
 * @Date: 2024-05-02 15:28:44
 * @LastEditors: Merlin
 * @LastEditTime: 2025-01-24 13:01:13
 * @Description: 
 */
import {getGameName} from '@/common/js/gameAbout';

export const useNavigator = (path) => {
    const localPath = useLocalePath();
    const target = localPath(path); // 计算目的地
    // console.log(path, "=>", target); 
    // ↓执行跳转 
    const router = useRouter();
    return router.push(target);
};


// ↓ 计算路径的方法 
// ↓ 之前方式报错 :to="useLocalePath()(route.path)" （在切换语言的时候在控制台会打印 warn 信息） 
// ↓ 用此方法不报错 :to="getLocalPath(route.path)"
export const getLocalPath = (path) => {
    const nuxt = useNuxtApp();
    const sFinalPath = nuxt.$localePath(path);
    return sFinalPath;
};


// ↓ 监测用户是否在查看某局游戏的结果，
// ↓ 结果为 true 则任由用户查看，不登录也能查看 
export function checkIfViewingHistory(
    oRouteGoTo?,
    oRouteFrom?,
){
    oRouteGoTo ||= useRoute();
    // ↓ 前往某个游戏页面 
    const toGamePage = getGameName(oRouteGoTo.path); 
    // ↓ 情况1：正在查看游戏历史 
    const isViewing = Boolean(
        toGamePage
        && oRouteGoTo?.query?.modal === 'BetDetails' // 窗口已经打开 
        && oRouteGoTo?.query?.data // 游戏历史 id 存在 
    );
    // ↓ 情况2：游戏历史窗口被关闭
    // ↓ 有可能现关闭了游戏历史窗口，但正在查看窗口内的子窗口“公平性说明窗口” 所以也认定可以逗留在当前页 
    // ↓ 你或有疑虑：如果用户关闭了游戏历史窗口但没打开“公平性窗口” 岂不是多余让他逗留在当前页？
    // ↓ 不会的，因为用户关闭游戏历史窗口时内部分判断并执行跳到未登录页 
    const bViewed = Boolean(
        toGamePage
        && oRouteFrom 
        && getGameName(oRouteFrom.path)
        && oRouteFrom.query?.modal == 'BetDetails'
        && oRouteFrom.query?.data
    );
    if (1 && import.meta.dev){
        console.log("正在查看游戏历史 | 查看公平性窗口", isViewing, bViewed); 
    }
    return isViewing || bViewed;
}

// ↓ 没登录就跳到特定页 
export async function jumpToNoLogPageByState(){
    const {hasLogged} = await getUserInfo();
    if (hasLogged) return;
    // ↓ 没登录，跳 
    const sNoLogInPage = '/information?key=notLoggedIn';
    useNavigator(sNoLogInPage);
}

